// extracted by mini-css-extract-plugin
module.exports = {"sorter":"Sorter-module__sorter___3Mdlw","leadingIcon":"Sorter-module__leadingIcon___mrwBE","caret":"Sorter-module__caret___3n1Go"};